import React from 'react'
import useFilteredFlightDeals from 'home/hooks/useFilteredFlightDeals'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import FlightDealsCarousel from './FlightDealsCarousel/FlightDealsCarousel'
import Image from 'components/Common/Image'
import Heading from 'LuxKit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer'
import { HOME_PAGE_FLIGHT_DEALS_THRESHOLD } from 'hooks/Flights/useCampaignsOrDeals'

interface Props {
  flightDeals: Array<App.FlightDeal>
  flightDealsLoading: boolean
}

function FlightDeals(props: Props) {
  const { flightDeals, flightDealsLoading } = props
  const {
    filteredFlightDeals,
    airports,
    defaultAirport,
    selectedAirport,
    setAirport,
    hasMultipleAirlines,
  } = useFilteredFlightDeals({ flightDeals })

  if (filteredFlightDeals.length < HOME_PAGE_FLIGHT_DEALS_THRESHOLD) {
    return null
  }

  return (
    <VerticalSpacer gap={16}>
      <LayoutContainer>
        {!!filteredFlightDeals.length && (
          <Group direction="horizontal" gap={8} verticalAlign="end">
            <Heading variant="heading4">Flights sale with{hasMultipleAirlines && ' our partner airlines'}</Heading>
            {!hasMultipleAirlines && <Image image={filteredFlightDeals[0].carrier.logo} width={100} alt={`Logo of ${filteredFlightDeals[0].carrier.name}`} />}
          </Group>
        )}
      </LayoutContainer>

      <FlightDealsCarousel
        title={`Limited-time flight offers ${airports.length > 1 ? ' from' : ''}`}
        onAirportChange={setAirport}
        airports={airports}
        flightDeals={flightDeals}
        defaultAirport={defaultAirport}
        selectedAirport={selectedAirport}
        loading={flightDealsLoading}
        showLookingForAFlight
        showViewAll
        isHomepage
      />
    </VerticalSpacer>
  )
}

export default FlightDeals
